import { apiInstanceImg } from '../../../../backend-api.setup'
import { ApiPathConfig } from '../../../../../config/ApiPathConfig'

const PostImportInfluencerPromises = (
  id_ean: string,
  influencer_promise: File,
) => {
  return apiInstanceImg.post(ApiPathConfig.IMPORT_INFLUENCER_PROMISES(id_ean), {
    influencer_promise,
  })
}

export default PostImportInfluencerPromises
